import {
  hasAccessToDoctorDashboard,
  hasAccessToOnPremDebug,
  hasAccessToPatientDashboard,
  hasAccessToUserManagement,
} from "core/model/accounts";
import { Account } from "core/types";
import {
  defaultRedirectPath,
  doctorDashboardRedirectPath,
  onpremDebugRedirectPath,
  userManagementRedirectPath,
} from ".";

export function getRedirectPathBasedOnRoles({
  account,
  activeRoles,
}: {
  account: Account | undefined;
  activeRoles: number[] | undefined;
}) {
  if (!activeRoles || activeRoles.length === 0) {
    return "/logout?reason=unauthorized";
  }

  // Check for patient dashboard access first (highest priority)
  if (hasAccessToPatientDashboard(account, activeRoles)) {
    return defaultRedirectPath;
  }

  if (hasAccessToDoctorDashboard(account, activeRoles)) {
    return doctorDashboardRedirectPath;
  }

  // Check for user management access (second priority)
  if (hasAccessToUserManagement(account, activeRoles)) {
    return userManagementRedirectPath;
  }

  // Check for onprem debug access (third priority)
  if (hasAccessToOnPremDebug(account, activeRoles)) {
    return onpremDebugRedirectPath;
  }

  // If no specific access, return default path
  return defaultRedirectPath;
}
